module.exports = __webpack_public_path__ + "static/img/home－image－cxyc.55863d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home－image－cxyc.jpg
// module id = OMvG
// module chunks = 1